<template>
    <div class="page-wrap stats-wrap">
        <div class="row row-header">
            <label>楼盘选择</label>
            <v-select :multiple="tab_type === 'compare'" taggable v-model="selected_house" :options="houses"></v-select>
            <div v-if="show_data_types">
                <data-select :selected="data_types" @change="changeDataType"/>
            </div>
            <div v-else class="time-wrap">
                <label>时间</label>
                <date-select show_today :type="type" :time_value="time_value" @changeTimeSelect="changeTimeSelect" @changeDate="changeDate"/>
            </div>
        </div>
        <div class="a-main">
            <ul class="a-tabs">
                <li v-for="(tab, i) in tabs" :key="i" :class="[{ active: tab.key === tab_type }]">
                    <a :data-key="tab.key" href="javascript:;" @click="changeTab">{{ tab.text }}</a>
                </li>
            </ul>
            <div class="a-main__content">
                <date-select
                    v-if="show_data_types"
                    :type="type"
                    :time_value="time_value"
                    @changeTimeSelect="changeTimeSelect"
                    @changeDate="changeDate"
                />
                <ad-position v-if="tab_type === 'position'" :building="building" :positions="positions" :dashboard="dashboard"></ad-position>
                <ad-data v-if="tab_type === 'data'" :clients_data="clients_data" :page="page" @changePage="changePage"></ad-data>
                <building
                    v-if="tab_type === 'building'"
                    :building_data_items="building_data_items"
                    :data_types="data_types"
                />
                <compare
                    v-if="tab_type === 'compare'"
                    :building_data_items="compare_building_data_items"
                    :data_types="data_types"
                />
            </div>
        </div>
    </div>
</template>
<script>
import Service from '@/service'
import Position from './_position'
import Data from './_data'
import Building from './_building'
import Compare from './_compare'

import DataSelect from './_data_select'
import DateSelect, { TYPES } from './_date_select'

import Dialog from '@/utils/dialog'

const TABS = [
    {
        key: 'position',
        text: '广告位查看'
    },
    {
        key: 'building',
        text: '楼盘数据'
    },
    {
        key: 'compare',
        text: '楼盘对比'
    }
]

const filterToday = (items) => {
    const date = new Date()
    const date_str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    const today = new Date(date_str).getTime()
    return items.filter(({ date }) => {
        return new Date(date) < today
    })
}

export default {
    name: 'STATS',
    beforeRouteLeave (to, from, next) {
        const { roles } = this.$store.state
        if (roles.indexOf('admin') > -1 || roles.indexOf('staff') > -1) {
            next()
            return
        } else if (roles.indexOf('advertiser') > -1) {
            if (to.path !== '/login') {
                next(false)
            } else {
                next()
            }
            return
        }
        next()
    },
    data () {
        return {
            tabs: TABS,
            tab_type: 'position',
            page: 1,
            positionQuery: {
                day: 'today'
            },
            query: {
                day: 'today'
            },
            building_id: '',
            targetable_id: '',
            targetable_type: '',
            houses: [],
            selected_house: null,
            clients_data: {},
            building: {},
            dashboard: {},
            positions: [],
            type: TYPES.POINT,
            time_value: 'today',
            data_types: [],
            building_data_items: [],
            compare_building_data_items: []
        }
    },
    computed: {
        roles () {
            const storeRoles = this.$store.getters.getRoles
            if (storeRoles.indexOf('advertiser') > -1) {
                return 'advertiser'
            } else if (storeRoles.indexOf('answerer') > -1) {
                return 'answerer'
            }
            return 'all'
        },
        show_data_types () {
            return this.tab_type === 'building' || this.tab_type === 'compare'
        }
    },
    mounted () {
        this.getAdvertisementTargetables()
        if (this.roles === 'advertiser') {
            this.getData()
        }
    },
    watch: {
        selected_house (v) {
            if (v && v.id) {
                this.changeHouse(v.id, v.type)
            } else if (v && v.length) {
                this.targetable_id = v
                this.getData()
            }
        }
    },
    methods: {
        getAdvertisementTargetables () {
            Service.getAdvertisementTargetables().then(({ data }) => {
                if (data.length > 0) {
                    this.houses = data.reduce((houses, { targetable_id: id, targetable_type: type, name, city }) => {
                        houses.push({
                            id,
                            type,
                            label: `${city}-${name.trim()}`,
                            city
                        })
                        return houses
                    }, [])
                }
            })
        },
        changeHouse (id, type) {
            this.building_id = id
            this.targetable_id = id
            this.targetable_type = type

            this.positionQuery.building_id = id

            this.query.targetable_id = id
            this.query.targetable_type = type
            this.getData()
        },
        changeTab (e) {
            const { key } = e.currentTarget.dataset
            this.targetable_id = ''
            this.targetable_type = ''
            this.tab_type = key
            this.selected_house = null
            this.data_types = []
            const is_building_data = key === 'building' || key === 'compare'
            const day = is_building_data ? 'yesterday' : 'today'
            this.positionQuery = {
                day
            }
            this.query = {
                day
            }
            this.type = TYPES.POINT
            this.time_value = day
            this.building_data_items = []
            this.compare_building_data_items = []
        },
        getData () {
            switch (this.tab_type) {
                case 'position':
                    this.getPosition()
                    break
                case 'data':
                    this.getStats()
                    break
                case 'building':
                    this.getBuildingData()
                    break
                case 'compare':
                    this.getBuildingCompare()
                    break
            }
        },
        async getBuildingData () {
            const { data } = await Service.getBuildingStats(this.building_id, {
                ...this.query
            })
            this.building_data_items = filterToday(data.items)
        },
        async getBuildingCompare () {
            const building_ids = this.selected_house.map(({ id }) => id)
            const { data } = await Service.getBuildingCompare(building_ids, {
                ...this.query
            })
            this.compare_building_data_items = data.items
        },
        getPosition () {
            Service.getStats(this.query).then(({ data }) => {
                this.building = data.building
                this.dashboard = data.dashboard
                this.positions = data.positions
            })
        },
        getStats () {
            Service.getClients({
                ...this.positionQuery,
                page: this.page
            }).then(({ data }) => {
                this.clients_data = data
            })
        },
        changePage (page) {
            this.page = page
            this.getData()
        },
        changeDate (start, end) {
            this.type = TYPES.RANGE
            this.positionQuery = {
                start_date: start,
                end_date: end
            }
            this.query = {
                start_date: start,
                end_date: end
            }
            if (this.roles === 'all') {
                if (this.targetable_id) {
                    this.query.targetable_id = this.targetable_id
                    this.query.targetable_type = this.targetable_type
                    this.positionQuery.building_id = this.building_id
                } else {
                    return
                }
            }
            this.getData()
        },
        changeTimeSelect (e) {
            const { type, value } = e.currentTarget.dataset
            this.type = type
            this.time_value = value
            this.positionQuery = {
                [type]: value
            }
            this.query = {
                [type]: value
            }
            if (this.roles === 'all') {
                if (this.targetable_id) {
                    this.query.targetable_id = this.targetable_id
                    this.query.targetable_type = this.targetable_type
                    this.positionQuery.building_id = this.building_id
                } else {
                    return
                }
            }
            this.getData()
        },
        changeDataType (types) {
            console.error(types)
            this.data_types = types
        }
    },
    components: {
        'ad-position': Position,
        'ad-data': Data,
        // SearchSelect,
        Dialog,
        Building,
        Compare,
        DataSelect,
        DateSelect
    }
}
</script>
<style lang="scss" scoped>
.stats-wrap {
    .a-main__content {
        padding-top: 0;
        .row {
            padding-left: 0;
        }
    }
}
.row {
    .item {
        display: inline-flex;
        align-items: center;
        margin-left: 20px;
    }
}
.time-wrap {
    display: inline-flex;
    align-items: center;
    margin-left: 1em;
}
</style>
